/** CustomEvent — SocketProvider ยิงหลัง webhook อัปเดตสถานะพัสดุ standalone */
export const PARCEL_LIST_REFRESH_EVENT = "forceRefreshParcelList";

/** ข้อความ reload จาก backend (ต้องตรงกับ api-external emit) */
export const PARCEL_LIST_SOCKET_RELOAD_MSG = "factory parcel status updated";

/** หลัง cron ได้ tracking_number (ต้องตรง factory-parcel-speed.constants) */
export const PARCEL_TRACKING_SOCKET_RELOAD_MSG = "factory parcel tracking generated";

/** เมื่อ credit balance เปลี่ยน (deduct/refund) — ต้องตรง PARCEL_SOCKET_CREDIT_UPDATED ใน BE */
export const CREDIT_BALANCE_SOCKET_RELOAD_MSG = "factory credit balance updated";

/** เมื่อ webhook ไปรษณีย์อัปเดต paid_amt / payment_status (ต้องตรง api-external emit) */
export const ORDER_PAYMENT_SOCKET_RELOAD_MSG = "order payment updated";
